export const redactEmail = (email: string) => {
  const [first, last] = email.split('@');
  // @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const firstRedacted = first.slice(0, 2) + '*'.repeat(first.length - 2);
  return `${firstRedacted}@${last}`;
};
